/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const PROMOTIONS_PER_PAGE = 4;

export const useGetPromotions = ({ page = 1, search = "", orderField = "", orderDirection = "" } = {}, queryParams) => {
  return useQuery({
    queryKey: queryKeys.promotions.list({ page, search, orderField, orderDirection }),
    queryFn: () =>
      fetcher({
        method: "GET",
        url: "/public/promotions",
        params: {
          page,
          on_page: PROMOTIONS_PER_PAGE,
          order_field: orderField,
          order_direction: orderDirection,
          ...(search ? { "filter[search]": search } : {}),
        },
      }),
    ...queryParams,
  });
};
